import { jobs } from './jobs';
import { Jobs } from './types';

export function getJobs(): Jobs {
  return jobs;
}
